import Player from '@vimeo/player';
import globals from'../globals.js';
import load_image from'../helpers/image-loader.js';
import load_video from'../helpers/video-loader.js';

var homeVimeoPlayers = [];

function home_player(){

 
    var header = document.querySelector('header');
    var homepage = document.querySelector('.homepage');

    var largeLogo = document.querySelector('.large-logo');

    // header.classList.remove('hide');

    if(largeLogo){

        header.classList.add('landing-pos');

        // document.body.addEventListener('click', function(){
        //     largeLogo.classList.add('hide');
        //     logo.style.opacity = 1;
        //     header.classList.remove('hide');
        //     landingPage.classList.remove('no-click');
        // });

        // largeLogo.classList.add('show');

        // setTimeout(function(){
        //     largeLogo.classList.add('hide');
        //     landingPage.classList.add('hidden');
        //     logo.style.opacity = 1;
        //     header.classList.remove('hide');
        //     homepage.classList.add('visable');

        //     for (let a = 0; a < homeVimeoPlayers.length; a++) {
        //         const homeVimeoPlayer = homeVimeoPlayers[a];

        //         if(homeVimeoPlayer.player){
        //             homeVimeoPlayer.player.destroy();
        //         }
                
        //     }

        // }, 4000);

    }else{
        header.classList.remove('landing-pos');
    }

    let loop = 0;
        
    homeVimeoPlayers.forEach((element) => {
        element.dataset.id = loop;

        let pl = element.querySelector('.home-player');

        var thumbVimeoPlayer = {
            elm: pl,
            id: pl.dataset.id,
            player: false,
            playing: false,
            parent: element,
            loaded: false,
            loading: false
        };

        homeVimeoPlayers.push(thumbVimeoPlayer);

        setTimeout(function(){
            element.classList.add('show')
        }, Math.floor((Math.random()*1000)+500));

        loop++;
    });


    function isElementOnScreen(element) {

        console.log(element);

        const rect = element.getBoundingClientRect();
      
        const isVisible = rect.top >= (rect.height * -1) && rect.bottom <= (window.innerHeight + rect.height);
     
        const isHidden = window.getComputedStyle(element).display === 'none';
      
        return isVisible && !isHidden;
    }

    function checkElementsInViewport() {

        let loop = 0;

        homeVimeoPlayers.forEach((element) => {

            let obj =  homeVimeoPlayers[element.dataset.id];
            
            if (isElementOnScreen(element)) {

                if(!obj.loading && !obj.loaded){
                    load_player(obj);
                }else{
                    if(obj.loaded && obj.playing){
                        obj.player.play();
                    }
                }

            } else {

                if(obj.loading && obj.loaded && obj.playing){
                    obj.player.pause();
                }
            
            }

        });

    };

    setInterval(function () { checkElementsInViewport() }, 1000);

    function load_player(obj){
        
        var parent = obj.parent;
        bind_player(obj, false);

    };


};

function bind_player(thumbVimeoPlayer, playing){

    if(!thumbVimeoPlayer.player){

        if(!thumbVimeoPlayer.loaded && !thumbVimeoPlayer.loading){
            
            thumbVimeoPlayer.loading = true;

            let autoplay = false;
            if(thumbVimeoPlayer.elm.classList.contains('autoplay')){
                autoplay = true;
            }

            const options = {
                id: thumbVimeoPlayer.id,
                resoponsive: true,
                background: true,
                controls: false,
                muted: 1,
                loading: 'lazy',
                cache: true,
                dnt: true,
                quality: "360p",
                loop: true
            };

            const player = new Player(thumbVimeoPlayer.elm, options);
            // player.setMaxBufferLength(5);
            thumbVimeoPlayer.player = player;

            player.on("play", function(data) {
                thumbVimeoPlayer.parent.classList.add('thumb-playing');
                thumbVimeoPlayer.playing = true;
            });

            player.on("pause", function(data) {
                thumbVimeoPlayer.playing = false;
            });

            thumbVimeoPlayer.loaded = true;


        }

    }else{

        if(thumbVimeoPlayer.loaded){
            
            if(playing){
                thumbVimeoPlayer.parent.classList.remove('thumb-playing');
                thumbVimeoPlayer.player.pause();
            }else{
                thumbVimeoPlayer.parent.classList.add('thumb-playing');
                thumbVimeoPlayer.player.play();
            }

        }

    }

}




export default home_player;